export default "/images/d20d034a4935bd2680ae5244b286edf9.avif";